<div class="page-loader text-center" [hidden]="!loading">
  <div class="loader"></div>
</div>
@if (page$ | async; as page) {
  @for (block of page.widgets | orderBy:['data.row', 'data.col']; track trackByFn($index, block)) {
    <core-block
      [block]="block"
      [ngStyle]="{padding: block.data.padding, block: block.data.margin}"
      class="core-block-l1 {{getBlockClassPosition(block, page.widgets[$index-1]) + ' ' + getBlockClasses(block)}}">
    </core-block>
  }
}
